<template>
  <div class="bg" :class="{'no-bg': !showBg}" :style="bgStyle">
    <div v-if="showSettings" class="settings-overlay" @click="closeSettings"></div>
    <!-- 时钟显示 -->
    <div class="timer" :style="{'transform': 'translateY(-50%) scale('+(scale/100)+')','filter': 'brightness('+brightness/100+')'}">
      <clock :num="num1" :ampm="hourFormat === 0" :text-color="textColor" :class="[showSecond?'timer_inner3':'timer_inner2']"></clock>
      <clock :num="num2" :text-color="textColor" :class="[showSecond?'timer_inner3':'timer_inner2']"></clock>
      <clock :num="num3" v-if="showSecond" :text-color="textColor" :class="[showSecond?'timer_inner3':'timer_inner2']"></clock>
      
      <!-- 日期和星期显示 -->
      <div class="date-display" :style="{color: textColor}">
        <div class="date-text">{{ dateText }} {{ weekdayText }}</div>
      </div>
    </div>

    <!-- 番茄钟运行显示 -->
    <div v-if="pomodoroRunning" class="pomodoro-display">
      <div class="pomodoro-time">{{ pomodoroTime }}</div>
      <div class="pomodoro-actions">
        <button @click="togglePomodoroFn" class="pomodoro-btn">
          {{ pomodoroIsRunning ? t('timer.pause') : t('timer.start') }}
        </button>
        <button @click="stopPomodoroFn" class="pomodoro-btn stop">
          {{ t('timer.stop') }}
        </button>
      </div>
    </div>

    <!-- 全屏和声音控制按钮 -->
    <div class="control-buttons">
      <button class="control-btn" @click="toggleSettings" :title="t('settings.title')">
        <Icon name="settings" :size="20" />
      </button>
      <button class="control-btn" @click="openDailyNews" :title="'每日新闻'">
        <Icon name="newspaper" :size="20" />
      </button>
      <button class="control-btn" @click="toggleFullscreen" :title="isFullscreen ? '退出全屏' : '全屏'">
        <Icon :name="isFullscreen ? 'minimize' : 'maximize'" :size="20" />
      </button>
      <button class="control-btn" @click="toggleClockSound" :title="clockSoundEnabled ? '关闭时钟声音' : '开启时钟声音'">
        <Icon :name="clockSoundEnabled ? 'volume' : 'volume-x'" :size="20" />
      </button>
    </div>

    <!-- 设置面板 -->
    <div class="set_box">
      <div class="set_box_item" v-show="showSettings">
        <ul class="set_box_inner">
          <!-- 语言切换 -->
          <li>
            <div class="setName">{{ t('settings.language') }}:</div>
            <ul class="pickItem">
              <li @click="switchLocaleFn('zh-CN')" :class="{'pick-active':locale==='zh-CN'}">中文</li>
              <li @click="switchLocaleFn('en-US')" :class="{'pick-active':locale==='en-US'}">EN</li>
            </ul>
          </li>

          <!-- 时间格式 -->
          <li>
            <div class="setName">{{ t('settings.hourFormat') }}:</div>
            <ul class="pickItem">
              <li @click="hourFormat=0; handleSettingChange()" :class="{'pick-active':hourFormat===0}">{{ t('format.hour12') }}</li>
              <li @click="hourFormat=1; handleSettingChange()" :class="{'pick-active':hourFormat===1}">{{ t('format.hour24') }}</li>
            </ul>
          </li>

          <!-- 缩放 -->
          <li>
            <div class="setName">{{ t('settings.scale') }}:</div>
            <slider v-model="scale" @update:model-value="handleSettingChange"></slider>
            <div style="width:32px;padding-left: 8px;">{{scale}}</div>
            <button class="timerBtn" @click="resetScale" style="margin-left: 8px;">{{ t('common.default') }}</button>
          </li>

          <!-- 亮度 -->
          <li>
            <div class="setName">{{ t('settings.brightness') }}:</div>
            <slider v-model="brightness" @update:model-value="handleSettingChange"></slider>
            <div style="width:32px;padding-left: 8px;">{{brightness}}</div>
          </li>

          <!-- 显示秒数 -->
          <li>
            <div class="setName">{{ t('settings.showSeconds') }}:</div>
            <label class="switch">
              <input type="checkbox" v-model="showSecond" @change="handleSettingChange">
              <span class="slider-round"></span>
            </label>
          </li>

          <!-- 背景显示 -->
          <li>
            <div class="setName">{{ t('settings.background') }}:</div>
            <label class="switch">
              <input type="checkbox" v-model="showBg" @change="handleSettingChange">
              <span class="slider-round"></span>
            </label>
          </li>

          <!-- 背景类型 -->
          <li v-if="showBg">
            <div class="setName">背景类型:</div>
            <ul class="pickItem">
              <li @click="bgType='color'; handleSettingChange()" :class="{'pick-active':bgType==='color'}">纯色</li>
              <li @click="bgType='bing'; fetchBingImage()" :class="{'pick-active':bgType==='bing'}">必应</li>
            </ul>
          </li>

          <!-- 背景颜色 -->
          <li v-if="showBg && bgType==='color'">
            <div class="setName">背景颜色:</div>
            <input type="color" v-model="bgColor" @change="handleSettingChange" class="color-picker">
            <button class="timerBtn" @click="resetBgColor" style="margin-left: 8px;">{{ t('common.default') }}</button>
          </li>

          <!-- 文字颜色 -->
          <li>
            <div class="setName">文字颜色:</div>
            <input type="color" v-model="textColor" @change="handleSettingChange" class="color-picker">
            <button class="timerBtn" @click="resetTextColor" style="margin-left: 8px;">{{ t('common.default') }}</button>
          </li>

          <!-- 番茄钟 -->
          <li>
            <div class="setName">{{ t('timer.pomodoro') }}:</div>
            <button class="timerBtn" @click="startPomodoroFn(pomodoroSettings.workDuration)">
              <span class="iconTomato"></span>
              <span style="vertical-align: middle;">{{pomodoroSettings.workDuration}}m</span>
            </button>
            <button class="timerBtn" @click="startPomodoroFn(pomodoroSettings.shortBreakDuration)">
              <span class="iconTime"></span>
              <span style="vertical-align: middle;">{{pomodoroSettings.shortBreakDuration}}m</span>
            </button>
            <button class="timerBtn stats-btn" @click="showStats = true" :title="t('pomodoro.viewStats')">
              <Icon name="chart" :size="16" />
            </button>
            <button class="timerBtn settings-btn" @click="showPomodoroSettings = true" :title="t('settings.pomodoro')">
              <Icon name="settings" :size="14" />
            </button>
          </li>

          <!-- 番茄钟统计 -->
          <li>
            <div class="setName">{{ t('stats.today') }}:</div>
            <div class="stats-info">
              <span class="stats-count"><Icon name="circle-dot" :size="16" color="#63c97a" /> {{ pomodoroStats.today.count }}</span>
              <span class="stats-time">{{ formatStatsDuration(pomodoroStats.today.duration) }}</span>
            </div>
          </li>

        </ul>
        <!-- 作者信息 -->
        <footer class="settings-footer">
          <a href="https://link3.cc/lunan" target="_blank">v1.0.0 @lunan 2026</a>
        </footer>
      </div>
    </div>

    <!-- 番茄钟统计面板 -->
    <PomodoroStats :show="showStats" @close="showStats = false" />

    <!-- 每日新闻弹窗 -->
    <div v-if="dailyNewsVisible" class="news-modal">
      <div class="settings-overlay" @click="closeDailyNews"></div>
      <div class="news-content">
        <div class="news-header">
          <h3>每日新闻简讯</h3>
          <div class="news-actions">
            <button class="timerBtn" @click="fetchDailyNews(true)" :disabled="dailyNewsLoading">刷新</button>
            <button class="timerBtn" @click="downloadDailyNews" :disabled="!dailyNewsImg">下载</button>
            <button class="close-btn" @click="closeDailyNews"><Icon name="close" :size="18" /></button>
          </div>
        </div>
        <div class="news-body">
          <div v-if="dailyNewsLoading" class="news-loading">加载中...</div>
          <div v-else-if="dailyNewsError" class="news-error">{{ dailyNewsError }}</div>
          <img v-else-if="dailyNewsImg" :src="dailyNewsImg" alt="每日新闻" />
          <div v-else class="news-empty">暂无新闻</div>
        </div>
      </div>
    </div>

    <!-- 番茄钟设置面板 -->
    <div v-if="showPomodoroSettings" class="pomodoro-settings">
      <div class="settings-overlay" @click="showPomodoroSettings = false"></div>
      <div class="settings-panel">
        <div class="settings-header">
          <h2>{{ t('settings.pomodoro') }}</h2>
          <button class="close-btn" @click="showPomodoroSettings = false"><Icon name="close" :size="18" /></button>
        </div>
        <div class="settings-content">
          <div class="setting-item">
            <label>{{ t('timer.pomodoro') }} (分钟):</label>
            <div class="input-group">
              <input type="number" min="1" max="120" v-model.number="pomodoroSettings.workDuration" />
              <span class="unit">min</span>
            </div>
          </div>
          <div class="setting-item">
            <label>{{ t('timer.shortBreak') }} (分钟):</label>
            <div class="input-group">
              <input type="number" min="1" max="60" v-model.number="pomodoroSettings.shortBreakDuration" />
              <span class="unit">min</span>
            </div>
          </div>
          <div class="setting-item">
            <label>{{ t('timer.longBreak') }} (分钟):</label>
            <div class="input-group">
              <input type="number" min="1" max="60" v-model.number="pomodoroSettings.longBreakDuration" />
              <span class="unit">min</span>
            </div>
          </div>
          <div class="setting-item">
            <label>{{ t('timer.sessionsBeforeLongBreak') }}:</label>
            <div class="input-group">
              <input type="number" min="1" max="10" v-model.number="pomodoroSettings.sessionsBeforeLongBreak" />
            </div>
          </div>
        </div>
        <div class="settings-actions">
          <button class="btn-save" @click="savePomodoroSettings">{{ t('common.save') }}</button>
          <button class="btn-cancel" @click="showPomodoroSettings = false">{{ t('common.cancel') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, toRefs, computed, ref, onBeforeUnmount } from 'vue'
import myPic from './assets/pic'
import clock from './components/clock.vue'
import slider from './components/slider'
import Icon from './components/Icon.vue'
import PomodoroStats from './components/PomodoroStats.vue'
import { useI18n } from './composables/useI18n'
import { usePomodoro } from './composables/usePomodoro'

export default {
  components: { clock, slider, Icon, PomodoroStats },
  setup () {
    // 国际化
    const { t, locale, switchLocale } = useI18n()
    
    // 番茄钟
    const { 
      startPomodoro, 
      stopPomodoro, 
      togglePause, 
      isRunning: pomodoroIsRunning,
      currentPomodoro: pomodoroRunning,
      formatTime: pomodoroTime,
      stats: pomodoroStats,
      settings: pomodoroSettings,
      updateSettings: updatePomodoroSettings
    } = usePomodoro()

    const showStats = ref(false)
    const showPomodoroSettings = ref(false)
    
    // 番茄钟设置的临时副本
    const pomodoroSettingsCopy = ref({
      workDuration: pomodoroSettings.workDuration,
      shortBreakDuration: pomodoroSettings.shortBreakDuration,
      longBreakDuration: pomodoroSettings.longBreakDuration,
      sessionsBeforeLongBreak: pomodoroSettings.sessionsBeforeLongBreak
    })

    // 从 localStorage 加载时钟设置
    const loadClockSettings = () => {
      try {
        const saved = localStorage.getItem('clock_settings')
        if (saved) {
          return JSON.parse(saved)
        }
      } catch (e) {
        console.error('Failed to load clock settings:', e)
      }
      return null
    }

    const clockSettings = loadClockSettings() || {
      hourFormat: 0,
      scale: 55,
      brightness: 100,
      showBg: true,
      showSecond: true,
      bgType: 'color',
      bgColor: '#000000',
      textColor: '#bbbbbb',
      bingImageUrl: ''
    }

    const data = reactive({
      pic_setting: myPic.pic_setting,
      // clock content
      num1: 11,
      num2: 0,
      num3: 0,
      // config
      // 12h 24h 024h
      hourFormat: clockSettings.hourFormat,
      scale: clockSettings.scale,
      brightness: clockSettings.brightness,
      showBg: clockSettings.showBg,
      bgType: clockSettings.bgType,
      bgColor: clockSettings.bgColor,
      textColor: clockSettings.textColor,
      bingImageUrl: clockSettings.bingImageUrl,
      fs: 22,
      showSecond: clockSettings.showSecond,
      my_h: 1,
      my_m: 2,
      my_s: 3,
      showSettings: false,
      dateText: '',
      weekdayText: ''
    })

    // 全屏和声音控制
    const isFullscreen = ref(false)
    const clockSoundEnabled = ref(localStorage.getItem('clock_sound_enabled') !== 'false')
    const clockAudio = new Audio('/clock-ticking.mp3')
    clockAudio.loop = true
    clockAudio.volume = 0.3

    // 每日新闻简讯状态
    const dailyNewsVisible = ref(false)
    const dailyNewsLoading = ref(false)
    const dailyNewsImg = ref('')
    const dailyNewsError = ref('')

    const NEWS_API = 'https://uapis.cn/api/v1/daily/news-image'

    // Helper: convert blob to base64 for storage
    const blobToBase64 = (blob) => new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.onloadend = () => resolve(reader.result)
      reader.onerror = reject
      reader.readAsDataURL(blob)
    })

    // Check cache (one day TTL)
    const loadCachedNews = () => {
      try {
        const raw = localStorage.getItem('daily_news_cache')
        const ts = localStorage.getItem('daily_news_cache_ts')
        if (raw && ts) {
          const age = Date.now() - Number(ts)
          if (age < 24 * 60 * 60 * 1000) {
            dailyNewsImg.value = raw
            return true
          }
        }
      } catch (e) {
        // ignore
      }
      return false
    }

    const saveCachedNews = (base64) => {
      try {
        localStorage.setItem('daily_news_cache', base64)
        localStorage.setItem('daily_news_cache_ts', Date.now().toString())
      } catch (e) {
        console.warn('Failed to cache news image:', e)
      }
    }

    const fetchDailyNews = async (force = false) => {
      dailyNewsError.value = ''
      if (!force && dailyNewsImg.value) return
      if (!force && loadCachedNews()) return

      dailyNewsLoading.value = true
      try {
        const resp = await fetch(NEWS_API, { method: 'GET' })
        if (!resp.ok) throw new Error('网络请求失败: ' + resp.status)
        const blob = await resp.blob()
        // Ensure it's an image/jpeg
        if (!blob.type || !blob.type.startsWith('image')) {
          // still try but warn
          console.warn('Unexpected mime type for news image:', blob.type)
        }
        const base64 = await blobToBase64(blob)
        dailyNewsImg.value = base64
        saveCachedNews(base64)
      } catch (e) {
        console.error('Fetch daily news failed:', e)
        dailyNewsError.value = e.message || String(e)
      } finally {
        dailyNewsLoading.value = false
      }
    }

    const openDailyNews = async () => {
      dailyNewsVisible.value = true
      // try load cached first, otherwise fetch
      if (!dailyNewsImg.value) {
        await fetchDailyNews(false)
      }
    }

    const closeDailyNews = () => {
      dailyNewsVisible.value = false
    }

    const downloadDailyNews = async () => {
      if (!dailyNewsImg.value) return
      try {
        const resp = await fetch(dailyNewsImg.value)
        const blob = await resp.blob()
        const url = URL.createObjectURL(blob)
        const now = new Date()
        const dateStr = `${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, '0')}${String(now.getDate()).padStart(2, '0')}`
        const a = document.createElement('a')
        a.href = url
        a.download = `每日新闻简讯-${dateStr}.jpg`
        document.body.appendChild(a)
        a.click()
        a.remove()
        URL.revokeObjectURL(url)
      } catch (e) {
        console.error('Download daily news failed:', e)
      }
    }

    // 日期和星期的文本
    const weekdaysZh = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']
    const weekdaysEn = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']

    const updateDateTime = () => {
      const now = new Date()
      const year = now.getFullYear()
      const month = now.getMonth() + 1
      const day = now.getDate()
      const weekdayIndex = now.getDay()
      
      if (locale.value === 'zh-CN') {
        data.dateText = `${year}年${month}月${day}日`
        data.weekdayText = weekdaysZh[weekdayIndex]
      } else {
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
        data.dateText = `${months[month - 1]} ${day}, ${year}`
        data.weekdayText = weekdaysEn[weekdayIndex]
      }
    }

    // 保存时钟设置到 localStorage
    const saveClockSettings = () => {
      try {
        localStorage.setItem('clock_settings', JSON.stringify({
          hourFormat: data.hourFormat,
          scale: data.scale,
          brightness: data.brightness,
          showBg: data.showBg,
          showSecond: data.showSecond,
          bgType: data.bgType,
          bgColor: data.bgColor,
          textColor: data.textColor,
          bingImageUrl: data.bingImageUrl
        }))
      } catch (e) {
        console.error('Failed to save clock settings:', e)
      }
    }

    // 监听设置变化并保存
    const handleSettingChange = () => {
      saveClockSettings()
    }

    const zeroNum = (n) => n < 10 ? '0' + n : String(n)

    const formatNum = (n) => {
      // 12h: 原样; 24h: 两位数字
      return data.hourFormat === 1 ? zeroNum(n) : n
    }

    const gettimer = () => {
      let t = new Date()
      let h = t.getHours()
      let m = t.getMinutes()
      let s = t.getSeconds()
      return {h,m,s}
    }

    let timer = setInterval(() => {
      let res = gettimer()
      data.num1 = formatNum(res.h)
      data.num2 = zeroNum(res.m)
      data.num3 = zeroNum(res.s)
      updateDateTime()
    }, 200)

    // 初始化日期
    updateDateTime()

    // 全屏切换
    const toggleFullscreen = () => {
      if (!document.fullscreenElement) {
        document.documentElement.requestFullscreen().then(() => {
          isFullscreen.value = true
        }).catch(err => {
          console.error('Failed to enter fullscreen:', err)
        })
      } else {
        document.exitFullscreen().then(() => {
          isFullscreen.value = false
        }).catch(err => {
          console.error('Failed to exit fullscreen:', err)
        })
      }
    }

    // 监听全屏变化
    document.addEventListener('fullscreenchange', () => {
      isFullscreen.value = !!document.fullscreenElement
    })

    // 时钟声音切换
    const toggleClockSound = () => {
      clockSoundEnabled.value = !clockSoundEnabled.value
      localStorage.setItem('clock_sound_enabled', clockSoundEnabled.value.toString())
      
      if (clockSoundEnabled.value) {
        clockAudio.play().catch(err => console.warn('Clock sound play failed:', err))
      } else {
        clockAudio.pause()
        clockAudio.currentTime = 0
      }
    }

    // 初始化时钟声音
    if (clockSoundEnabled.value) {
      // 延迟一点启动，避免页面加载时立即播放
      setTimeout(() => {
        clockAudio.play().catch(err => console.warn('Clock sound auto-play failed:', err))
      }, 500)
    }

    // 清理定时器
    onBeforeUnmount(() => {
      if (timer) clearInterval(timer)
    })

    // 番茄钟相关方法
    const startPomodoroFn = (duration) => {
      const safeDuration = Math.max(1, Number(duration) || 25)
      startPomodoro(safeDuration)
    }

    const stopPomodoroFn = () => {
      if (!pomodoroRunning.value) return
      const saveIt = window.confirm(t('common.save') + '?')
      stopPomodoro(saveIt)
    }

    const togglePomodoroFn = () => {
      togglePause()
    }

    const switchLocaleFn = (newLocale) => {
      switchLocale(newLocale)
      updateDateTime() // 切换语言后更新日期显示
    }

    const toggleSettings = () => {
      data.showSettings = !data.showSettings
    }

    const closeSettings = () => {
      data.showSettings = false
    }

    const formatStatsDuration = (minutes) => {
      const hours = Math.floor(minutes / 60)
      const mins = minutes % 60
      if (hours > 0) {
        return `${hours}h${mins}m`
      }
      return `${mins}m`
    }

    const savePomodoroSettings = () => {
      updatePomodoroSettings(pomodoroSettingsCopy.value)
      showPomodoroSettings.value = false
    }

    const resetScale = () => {
      data.scale = 55
      handleSettingChange()
    }

    const resetBgColor = () => {
      data.bgColor = '#000000'
      handleSettingChange()
    }

    const resetTextColor = () => {
      data.textColor = '#bbbbbb'
      handleSettingChange()
    }

    // 获取必应每日一图
    const fetchBingImage = async () => {
      try {
        const resp = await fetch('https://uapis.cn/api/v1/image/bing-daily')
        if (!resp.ok) throw new Error('Failed to fetch Bing image')
        const blob = await resp.blob()
        const url = URL.createObjectURL(blob)
        data.bingImageUrl = url
        data.bgType = 'bing'
        handleSettingChange()
      } catch (e) {
        console.error('Fetch Bing image failed:', e)
      }
    }

    // 计算背景样式
    const bgStyle = computed(() => {
      if (!data.showBg) return {}
      if (data.bgType === 'bing' && data.bingImageUrl) {
        return {
          backgroundImage: `url(${data.bingImageUrl})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }
      }
      return {
        backgroundColor: data.bgColor
      }
    })

    // 初始化必应图片（如果之前选择了必应）
    if (data.showBg && data.bgType === 'bing' && !data.bingImageUrl) {
      fetchBingImage()
    }

    // 请求通知权限
    if ('Notification' in window && Notification.permission === 'default') {
      Notification.requestPermission()
    }

    return {
      ...toRefs(data),
      t,
      locale,
      switchLocaleFn,
      showStats,
      showPomodoroSettings,
      toggleSettings,
      closeSettings,
      handleSettingChange,
      resetScale,
      resetBgColor,
      resetTextColor,
      fetchBingImage,
      bgStyle,
      // daily news
      dailyNewsVisible,
      dailyNewsLoading,
      dailyNewsImg,
      dailyNewsError,
      openDailyNews,
      closeDailyNews,
      fetchDailyNews,
      downloadDailyNews,
      pomodoroRunning,
      pomodoroIsRunning,
      pomodoroTime,
      pomodoroStats,
      pomodoroSettings: pomodoroSettingsCopy,
      savePomodoroSettings,
      startPomodoroFn,
      stopPomodoroFn,
      togglePomodoroFn,
      formatStatsDuration,
      isFullscreen,
      clockSoundEnabled,
      toggleFullscreen,
      toggleClockSound
    }
  }
}
</script>

<style lang="less">
@import './assets/pic.less';

body{
  margin: 0;
}
ul{
  margin: 0;
  padding: 0;
  list-style-type: none;
}
button { 
  border:none; 
  padding:0;
  margin:0;
  outline-style:none; 
}

.bg{
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #000;
}

.bg.no-bg {
  background-color: #111;
}

.settings-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  z-index: 10;
}

.news-modal {
  position: fixed;
  inset: 0;
  z-index: 200;
  overflow-y: auto;
  padding: 6vh 0;
}
.news-modal .settings-overlay {
  z-index: 200;
}
.news-content {
  position: relative;
  z-index: 210;
  background: rgba(28, 28, 32, 0.9);
  backdrop-filter: blur(32px) saturate(1.2);
  -webkit-backdrop-filter: blur(32px) saturate(1.2);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 20px;
  padding: 20px;
  width: 80%;
  max-width: 900px;
  margin: 0 auto;
  box-shadow: 0 24px 80px rgba(0, 0, 0, 0.4);
  animation: settingsSlideIn 0.35s cubic-bezier(0.16, 1, 0.3, 1);
}
.news-header { display:flex; justify-content:space-between; align-items:center; }
.news-header h3 { margin: 0; color: #e8e8ec; font-weight: 600; }
.news-actions { display:flex; gap:8px; align-items:center }
.news-actions .close-btn {
  background: rgba(255, 255, 255, 0.06);
  border: none;
  color: #8b8b94;
  cursor: pointer;
  padding: 0;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}
.news-actions .close-btn:hover {
  background: rgba(255, 255, 255, 0.12);
  color: #e8e8ec;
}
.news-body {
  margin-top: 16px;
  text-align: center;
}
.news-body img {
  max-width: 100%;
  max-height: 170vh;
  width: auto;
  height: auto;
  object-fit: contain;
  display: block;
  margin: 0 auto;
  border-radius: 8px;
}
.news-loading, .news-error, .news-empty { color:#a8a8b0; padding:24px; font-size: 14px; }

.timer{
  position: relative;
  top: 50%;
  display: flex;
  justify-content: space-evenly;
}

.timer_inner2{
  width: 47.5vw;
  height: 47.5vw;
  font-size: 34vw;

  @media (max-width: 768px) {
    width: 45vw;
    height: 45vw;
    font-size: 32vw;
  }
}

.timer_inner3{
  width: 30vw;
  height: 30vw;
  font-size: 22vw;

  @media (max-width: 768px) {
    width: 28vw;
    height: 28vw;
    font-size: 20vw;
  }
}

/* 番茄钟运行显示 */
.pomodoro-display {
  position: fixed;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(28, 28, 32, 0.8);
  backdrop-filter: blur(24px) saturate(1.2);
  -webkit-backdrop-filter: blur(24px) saturate(1.2);
  padding: 24px 44px;
  border-radius: 20px;
  text-align: center;
  z-index: 100;
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.3);
  animation: pomodoroSlideIn 0.4s cubic-bezier(0.16, 1, 0.3, 1);

  @media (max-width: 768px) {
    top: 12px;
    padding: 18px 28px;
    width: 80%;
    border-radius: 16px;
  }

  .pomodoro-time {
    font-size: 52px;
    color: #63c97a;
    font-weight: 700;
    margin-bottom: 18px;
    letter-spacing: -0.03em;
    text-shadow: 0 0 40px rgba(99, 201, 122, 0.2);

    @media (max-width: 768px) {
      font-size: 38px;
      margin-bottom: 14px;
    }
  }

  .pomodoro-actions {
    display: flex;
    gap: 12px;
    justify-content: center;

    @media (max-width: 768px) {
      gap: 8px;
    }
  }

  .pomodoro-btn {
    padding: 10px 24px;
    background: linear-gradient(135deg, #63c97a, #4aad62);
    color: white;
    border: none;
    border-radius: 10px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    transition: all 0.25s cubic-bezier(0.16, 1, 0.3, 1);
    box-shadow: 0 4px 12px rgba(99, 201, 122, 0.25);

    @media (max-width: 768px) {
      padding: 8px 18px;
      font-size: 13px;
    }

    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 6px 20px rgba(99, 201, 122, 0.35);
    }

    &.stop {
      background: rgba(255, 255, 255, 0.08);
      color: #f87171;
      border: 1px solid rgba(248, 113, 113, 0.3);
      box-shadow: none;

      &:hover {
        background: rgba(248, 113, 113, 0.15);
        box-shadow: 0 4px 12px rgba(248, 113, 113, 0.2);
      }
    }
  }
}

@keyframes pomodoroSlideIn {
  from { opacity: 0; transform: translateX(-50%) translateY(-12px); }
  to   { opacity: 1; transform: translateX(-50%) translateY(0); }
}

/* 日期和星期显示 */
.date-display {
  position: absolute;
  left: 0;
  right: 0;
  top: 100%;
  margin-top: 3vw;
  text-align: center;
  color: #a8a8b0;

  @media (max-width: 768px) {
    margin-top: 4vw;
  }

  .date-text {
    font-size: 2.2vw;
    font-weight: 400;
    letter-spacing: 0.12em;
    white-space: nowrap;
    opacity: 0.7;

    @media (max-width: 768px) {
      font-size: 3.5vw;
    }
  }
}

/* 全屏和声音控制按钮 */
.control-buttons {
  position: fixed;
  top: 20px;
  right: 20px;
  display: flex;
  gap: 10px;
  z-index: 200;

  @media (max-width: 768px) {
    top: 12px;
    right: 12px;
    gap: 8px;
  }

  .control-btn {
    width: 44px;
    height: 44px;
    background: rgba(28, 28, 32, 0.6);
    backdrop-filter: blur(16px) saturate(1.2);
    -webkit-backdrop-filter: blur(16px) saturate(1.2);
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 12px;
    color: #a8a8b0;
    font-size: 18px;
    cursor: pointer;
    transition: all 0.25s cubic-bezier(0.16, 1, 0.3, 1);
    display: flex;
    align-items: center;
    justify-content: center;

    @media (max-width: 768px) {
      width: 40px;
      height: 40px;
      font-size: 16px;
    }

    &:hover {
      background: rgba(99, 201, 122, 0.15);
      border-color: rgba(99, 201, 122, 0.3);
      color: #e8e8ec;
      transform: translateY(-1px);
      box-shadow: 0 4px 16px rgba(99, 201, 122, 0.15);
    }

    &:active {
      transform: translateY(0) scale(0.96);
    }
  }
}

.set_box{
  position: fixed;
  bottom: 8%;
  right: 8%;
  width: 200px;
  height: 200px;
  z-index: 20;

  @media (max-width: 768px) {
    bottom: 20px;
    right: 20px;
    width: 150px;
    height: 150px;
  }

  &:hover .setting{
    opacity: 1;
  }
}

.set_box_item{
  position: fixed;
  bottom: 10%;
  right: 8%;
  width: 430px;
  max-height: 80vh;
  overflow-y: auto;
  background: rgba(28, 28, 32, 0.75);
  backdrop-filter: blur(32px) saturate(1.3);
  -webkit-backdrop-filter: blur(32px) saturate(1.3);
  border-radius: 20px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 24px 80px rgba(0, 0, 0, 0.4), 0 0 0 1px rgba(255, 255, 255, 0.04) inset;
  animation: settingsSlideIn 0.35s cubic-bezier(0.16, 1, 0.3, 1);

  @media (max-width: 1024px) {
    right: 4%;
    width: 380px;
  }

  @media (max-width: 768px) {
    bottom: 60px;
    right: 12px;
    width: 90vw;
    max-width: 320px;
    max-height: 70vh;
    border-radius: 16px;
  }
}

@keyframes settingsSlideIn {
  from { opacity: 0; transform: translateY(12px) scale(0.95); }
  to   { opacity: 1; transform: translateY(0) scale(1); }
}

.set_box_inner{
  padding: 24px;
  padding-bottom: 16px;
  color: #e8e8ec;
  font-size: 15px;

  @media (max-width: 768px) {
    padding: 16px;
    padding-bottom: 12px;
    font-size: 13px;
  }

  &>li{
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    padding: 4px 0;

    @media (max-width: 768px) {
      margin-bottom: 12px;
      flex-wrap: wrap;
    }
  }
}

.setting{
  position: absolute;
  bottom: 0;
  right: 0;
  width: 36px;
  height: 36px;
  opacity: 0;
  transition: all 0.5s ease-in-out;
  cursor: pointer;

  @media (max-width: 768px) {
    opacity: 0.7;
    width: 32px;
    height: 32px;
  }

  &:hover{
    transform: rotateZ(120deg);
    opacity: 1;
  }
}

.pickItem{
  display: flex;
  text-align: center;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  border: 1px solid rgba(255, 255, 255, 0.1);

  &>li{
    box-sizing: border-box;
    width: 60px;
    height: 28px;
    line-height: 26px;
    border-right: 1px solid rgba(255, 255, 255, 0.08);
    font-size: 13px;
    font-weight: 500;
    transition: all 0.2s ease;
    color: #8b8b94;
    background: rgba(255, 255, 255, 0.04);

    @media (max-width: 768px) {
      width: 50px;
      height: 26px;
      line-height: 24px;
      font-size: 12px;
    }

    &:last-child{
      border-right: none;
    }

    &:hover:not(.pick-active){
      background: rgba(255, 255, 255, 0.08);
      color: #a8a8b0;
    }
  }
}

.pick-active{
  color: #1c1c20;
  background: linear-gradient(135deg, #a8a8b0, #e8e8ec);
  font-weight: 600;
}

.setName{
  width: 116px;
  margin-right: 12px;
  text-align: right;
  color: #a8a8b0;
  font-weight: 500;
  font-size: 14px;

  @media (max-width: 768px) {
    width: 100%;
    text-align: left;
    margin-bottom: 6px;
  }
}

.color-picker {
  width: 52px;
  height: 28px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 8px;
  background: transparent;
  cursor: pointer;
  padding: 2px;
  
  &::-webkit-color-swatch-wrapper {
    padding: 2px;
  }
  
  &::-webkit-color-swatch {
    border: none;
    border-radius: 4px;
  }
}

.timerBtn{
  box-sizing: border-box;
  height: 28px;
  padding: 0 12px;
  border-radius: 8px;
  margin-right: 6px;
  background: rgba(255, 255, 255, 0.08);
  color: #a8a8b0;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  border: 1px solid rgba(255, 255, 255, 0.08);
  transition: all 0.2s ease;

  @media (max-width: 768px) {
    height: 26px;
    font-size: 12px;
    padding: 0 10px;
  }

  &:hover{
    background: rgba(255, 255, 255, 0.14);
    color: #e8e8ec;
    border-color: rgba(255, 255, 255, 0.15);
  }

  &:active{
    background: rgba(255, 255, 255, 0.06);
    transform: scale(0.97);
  }

  &.stats-btn {
    padding: 0 8px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  &.settings-btn {
    padding: 0 8px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
}

.iconTime{
  display: inline-block;
  width: 20px;
  height: 20px;
  vertical-align: middle;
  background-image: url(@timer);
  background-size: contain;

  @media (max-width: 768px) {
    width: 16px;
    height: 16px;
  }
}

.iconTomato{
  display: inline-block;
  width: 20px;
  height: 20px;
  margin-top: -3px;
  vertical-align: middle;
  background-image: url(@tomato);
  background-size: contain;

  @media (max-width: 768px) {
    width: 16px;
    height: 16px;
  }
}

.stats-info {
  display: flex;
  gap: 12px;
  align-items: center;
  color: #63c97a;

  @media (max-width: 768px) {
    gap: 8px;
    font-size: 13px;
  }

  .stats-count {
    font-weight: 600;
    font-size: 14px;
    display: inline-flex;
    align-items: center;
    gap: 4px;
  }

  .stats-time {
    color: #8b8b94;
    font-size: 13px;
  }
}

footer {
  text-align: center;
  padding: 12px;

  a {
    color: #636366;
    text-decoration: none;
    font-size: 11px;
    font-weight: 500;
    letter-spacing: 0.02em;
    transition: color 0.2s ease;

    &:hover {
      color: #a8a8b0;
    }
  }
}

.settings-footer {
  text-align: center;
  padding: 12px 20px 8px;
  border-top: 1px solid rgba(255, 255, 255, 0.04);
  margin-top: 4px;

  a {
    color: #636366;
    text-decoration: none;
    font-size: 11px;
    font-weight: 500;
    letter-spacing: 0.02em;
    transition: color 0.2s ease;

    &:hover {
      color: #a8a8b0;
    }
  }
}

/* toggle switch */
.switch {
  position: relative;
  display: inline-block;
  width: 44px;
  height: 24px;
}

.switch input { display:none; }

.slider-round {
  position: absolute;
  cursor: pointer;
  top: 0; left: 0; right: 0; bottom: 0;
  background-color: rgba(255, 255, 255, 0.1);
  transition: .25s cubic-bezier(0.16, 1, 0.3, 1);
  border-radius: 24px;
}

.slider-round:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background-color: #8b8b94;
  transition: .25s cubic-bezier(0.16, 1, 0.3, 1);
  border-radius: 50%;
  box-shadow: 0 1px 3px rgba(0,0,0,0.3);
}

input:checked + .slider-round {
  background: linear-gradient(135deg, #63c97a, #4aad62);
}

input:checked + .slider-round:before {
  transform: translateX(20px);
  background-color: #fff;
}

.number-input {
  width: 70px;
  height: 32px;
  margin-right: 8px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.05);
  color: #e8e8ec;
  padding: 2px 8px;
  font-size: 14px;
  transition: all 0.2s ease;

  &:focus {
    outline: none;
    border-color: rgba(99, 201, 122, 0.5);
    box-shadow: 0 0 0 3px rgba(99, 201, 122, 0.1);
  }
}

/* 番茄钟设置面板 */
.pomodoro-settings {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
}

.pomodoro-settings .settings-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
}

.pomodoro-settings .settings-panel {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(28, 28, 32, 0.85);
  backdrop-filter: blur(32px) saturate(1.3);
  -webkit-backdrop-filter: blur(32px) saturate(1.3);
  border-radius: 20px;
  padding: 28px;
  max-width: 400px;
  width: 90%;
  max-height: 80vh;
  overflow-y: auto;
  z-index: 1000;
  box-shadow: 0 24px 80px rgba(0, 0, 0, 0.5), 0 0 0 1px rgba(255, 255, 255, 0.06);
  color: #e8e8ec;
  animation: settingsSlideIn 0.35s cubic-bezier(0.16, 1, 0.3, 1);
}

.pomodoro-settings .settings-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  padding-bottom: 16px;

  h2 {
    margin: 0;
    font-size: 18px;
    color: #e8e8ec;
    font-weight: 600;
  }

  .close-btn {
    background: rgba(255, 255, 255, 0.06);
    border: none;
    color: #8b8b94;
    font-size: 18px;
    cursor: pointer;
    padding: 0;
    width: 32px;
    height: 32px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;

    &:hover {
      background: rgba(255, 255, 255, 0.12);
      color: #fff;
    }
  }
}

.pomodoro-settings .settings-content {
  margin-bottom: 20px;
}

.setting-item {
  margin-bottom: 18px;

  label {
    display: block;
    margin-bottom: 8px;
    color: #a8a8b0;
    font-size: 13px;
    font-weight: 500;
  }

  .input-group {
    display: flex;
    align-items: center;
    gap: 8px;

    input {
      width: 100%;
      height: 36px;
      border: 1px solid rgba(255, 255, 255, 0.1);
      border-radius: 10px;
      background: rgba(255, 255, 255, 0.05);
      color: #e8e8ec;
      padding: 0 12px;
      font-size: 14px;
      transition: all 0.2s ease;

      &:focus {
        outline: none;
        border-color: rgba(99, 201, 122, 0.5);
        box-shadow: 0 0 0 3px rgba(99, 201, 122, 0.1);
        background: rgba(255, 255, 255, 0.08);
      }
    }

    .unit {
      color: #636366;
      font-size: 12px;
      min-width: 30px;
      font-weight: 500;
    }
  }
}

.pomodoro-settings .settings-actions {
  display: flex;
  gap: 12px;
  justify-content: flex-end;

  button {
    padding: 10px 20px;
    border-radius: 10px;
    border: none;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.25s cubic-bezier(0.16, 1, 0.3, 1);

    &.btn-save {
      background: linear-gradient(135deg, #63c97a, #4aad62);
      color: white;
      box-shadow: 0 4px 12px rgba(99, 201, 122, 0.25);

      &:hover {
        transform: translateY(-1px);
        box-shadow: 0 6px 20px rgba(99, 201, 122, 0.35);
      }
    }

    &.btn-cancel {
      background: rgba(255, 255, 255, 0.06);
      color: #a8a8b0;
      border: 1px solid rgba(255, 255, 255, 0.08);

      &:hover {
        background: rgba(255, 255, 255, 0.1);
        color: #e8e8ec;
      }
    }
  }
}

.settings-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 8px;
}
</style>
